import React, { useState, useEffect } from 'react'
import { fetch_all_breakfast_information } from "../../api/cafeAPI";
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import notify from '../../utils/IANotification';
import { tidy_date } from '../../utils/helper';
import { MdAdd, MdEdit } from 'react-icons/md';
import DataTable from '../../components/ui/DataTable';
import Button from '../../components/ui/Button';

export default function AdminCafePage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()


  const [breakfastData, setBreakfastData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  const fetchBreakfastInformation = async () => {
    setLoading(true);
    let data = await fetch_all_breakfast_information();
    if (data.status === 200) {
      // sort by datetime
      let temp = data.data.sort((a, b) => {
        return new Date(b.datetime) - new Date(a.datetime);
      });
      setBreakfastData(temp);
    } else {
      notify({ type: "error", message: data.message });
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchBreakfastInformation()
  }, [])


  const table_columns = [
    {
      header: "Name",
      accessor: "name"
    },
    {
      header: "Items",
      accessor: "menu",
      modifier: (data) => `${data?.length} items`,
    },
    {
      header: "Name",
      accessor: "name"
    },
    {
      header: "Published",
      accessor: "is_published",
      modifier: (data) => (data ? "Published" : "Draft"),
    },
    {
      header: "Date Available",
      accessor: "datetime",
      modifier: (data) => tidy_date(data)
    }
  ]

  return (
    <AdminLayout
      navSelected={"Cafe"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Cafe</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/cafe/details?breakfast_id=new")
            }}
          >
            <MdAdd size={16} />
            New Breakfast
          </button>
        </>
      }
    >
      {/* <div className="flex-row items-center flex justify-between w-100">
        <h1 className='medium'>Breakfast Information</h1>
        <button
          className="button flex-row items-center flex gap-2"
          onClick={() => {
            navigate("/admin/cafe/details?breakfast_id=new")
          }}
        >
          <MdAdd size={15} />
          Breakfast
        </button>
      </div> */}

      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {breakfastData.map((data, index) => {
            if (!JSON.stringify(data)?.toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">
                  <h3>{data?.name}</h3>
                  <h3>{tidy_date(data?.datetime)}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/cafe/details?breakfast_id=" + data.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}

          <DataTable
            columns={table_columns}
            data={breakfastData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/cafe/details?breakfast_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
